import styled from 'styled-components';

export const ContentButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  margin-top: 40px;
`;
